module.exports = __webpack_public_path__ + "img/background-welcome.22bca2f6.svg";